export default "__VITE_ASSET__CtaK76____"